const normalizePermissionName = (value) =>
    (value || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();

export const hasViewPermission = (privileges, permissionName) => {
    const permissionNames = Array.isArray(permissionName) ? permissionName : [permissionName];
    const normalizedPermissionNames = permissionNames
        .map(normalizePermissionName)
        .filter(Boolean);

    if (normalizedPermissionNames.length === 0) {
        return true;
    }

    return (privileges || []).some((modulePrivilege) =>
        (modulePrivilege.privileges || []).some((submodulePrivilege) =>
            normalizedPermissionNames.includes(normalizePermissionName(submodulePrivilege.nombre)) && submodulePrivilege.ver
        )
    );
};

export const filterMenuItemsByPrivileges = (menuItems, privileges, currentUser) => {
    if (!menuItems?.items) {
        return menuItems;
    }

    return {
        ...menuItems,
        items: menuItems.items
            .map((item) => filterMenuNode(item, privileges, currentUser))
            .filter(Boolean)
    };
};

const filterMenuNode = (item, privileges, currentUser) => {
    if (item.alwaysVisible) {
        return item;
    }

    if (item.adminOnly && !currentUser?.esAdmin) {
        return null;
    }

    if (item.children?.length) {
        const children = item.children
            .map((child) => filterMenuNode(child, privileges, currentUser))
            .filter(Boolean);

        return children.length > 0 ? {...item, children} : null;
    }

    return hasViewPermission(privileges, item.requiredPermission || item.title) ? item : null;
};
